module.exports = __webpack_public_path__ + "img/media.117e085d.svg";